import BeanTypeSelect from './BeanTypeSelect.vue';
import beansMixin from './mixin';

export { beansMixin };
export default BeanTypeSelect;
